var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: true, "max-width": "700" },
      on: {
        input: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(
                " Kela-status: " + _vm._s(_vm.transportEvent.orderId) + " "
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _vm.batchInfo
                ? _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "subtitle-2 mb-1" }, [
                        _vm._v("Erätiedot")
                      ]),
                      _c("v-simple-table", { attrs: { dense: "" } }, [
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("Erä")])]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.batchInfo.siirtotunnus))
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("Alue")])]),
                            _c("td", [_vm._v(_vm._s(_vm.batchInfo.region))])
                          ]),
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("TilitysNro")])]),
                            _c("td", [_vm._v(_vm._s(_vm.batchInfo.tilitysNro))])
                          ]),
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("Vuosi")])]),
                            _c("td", [_vm._v(_vm._s(_vm.batchInfo.year))])
                          ]),
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("Lähetetty")])]),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.formatDateTime(_vm.batchInfo.sentAt))
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [_c("strong", [_vm._v("PAL-status")])]),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      color:
                                        _vm.batchInfo.feedbackStatus === "OK"
                                          ? "green"
                                          : _vm.batchInfo.feedbackStatus
                                          ? "red"
                                          : "grey"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.batchInfo.feedbackStatus ||
                                            "Odottaa"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                : _vm.batchLoading
                ? _c(
                    "div",
                    { staticClass: "text-center py-2" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "20" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", { staticClass: "mb-3" }),
              _c("div", { staticClass: "subtitle-2 mb-2" }, [
                _vm._v("Kela-statushistoria")
              ]),
              _vm.historyLoading
                ? _c(
                    "div",
                    { staticClass: "text-center py-2" },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "20" }
                      })
                    ],
                    1
                  )
                : _vm.history.length === 0
                ? _c("div", { staticClass: "grey--text text-caption" }, [
                    _vm._v(" Ei vielä TIL-statuksia. ")
                  ])
                : _c("v-simple-table", { attrs: { dense: "" } }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Tila")]),
                        _c("th", [_vm._v("Muutosversio")]),
                        _c("th", [_vm._v("Kelan päätös")]),
                        _c("th", [_vm._v("Maksettu")]),
                        _c("th", [_vm._v("Pyydetty")]),
                        _c("th", [_vm._v("Hylkäysperuste")])
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.history, function(row) {
                        return _c("tr", { key: row.id }, [
                          _c(
                            "td",
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: _vm.statusColor(row.settlementStatus)
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.settlementStatusLabel ||
                                          _vm.statusLabel(row.settlementStatus)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("td", [_vm._v(_vm._s(row.muutosversio || "—"))]),
                          _c("td", [
                            _vm._v(_vm._s(_vm.formatDate(row.ratkaisupvm)))
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                row.maksettuKorvaus != null
                                  ? _vm.formatCurrency(row.maksettuKorvaus)
                                  : "—"
                              )
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                row.haettuKorvaus != null
                                  ? _vm.formatCurrency(row.haettuKorvaus)
                                  : "—"
                              )
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "text-caption",
                                attrs: { title: row.rejectionInfo }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.rejectionInfo
                                        ? row.rejectionInfo.substring(0, 50) +
                                            (row.rejectionInfo.length > 50
                                              ? "…"
                                              : "")
                                        : "—"
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }